import React from 'react';
import PropTypes from 'prop-types';
import { alpha, styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton, Typography } from '@mui/material';

import { bgBlur } from '../../../utils/cssStyles';
import Iconify from '../../../components/iconify';
import AccountPopover from './AccountPopover';
import Theme from '../../theme/Theme';
import Notification from './Notification';

const NAV_WIDTH = 280;
const HEADER_MOBILE = 64;
const HEADER_DESKTOP = 92;
const ONLY_ICON = true;

const StyledRoot = styled(AppBar)(({ theme, scrolled }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: scrolled ? '0px 2px 4px rgba(0, 0, 0, 0.1)' : '0px 1px 2px rgba(0, 0, 0, 0.05)',
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

export default function Header({ scrolled, onOpenNav }) {
  return (
    <StyledRoot scrolled={scrolled}
      sx={{
        bgcolor: (theme) => (theme.palette.mode === 'light' ? '#cee8e9' : ''),
        backgroundImage: (theme) =>
          `linear-gradient(135deg, ${alpha(theme.palette.primary.lighter, 0)} 0%, ${alpha(
            theme.palette.primary.light,
            0.24
          )} 100%)`,
      }}>
      <StyledToolbar>
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { lg: 'none' },
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        <Typography variant="h6" sx={{ display: { xs: 'none', sm: 'block' }, color: 'darkgray' }}>
          የሰሜን ሸዋ ሀገረ ስብከት የመረጃ አስተዳደር ስርዓት!
        </Typography>
        <Typography variant="h6" sx={{ display: { xs: 'block', sm: 'none' }, color: 'darkgray' }}>
          አቡቀለምሲስ
        </Typography>

        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
        >
          <Theme ONLY_ICON={ONLY_ICON} />
          <Notification />
          <AccountPopover />
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}

Header.propTypes = {
  onOpenNav: PropTypes.func,
  scrolled: PropTypes.bool,
};
